import './index.css';
import logo from "../../assets/logo_mini_yourfairshare2.png";
import { useState } from 'react';
import Output from './Output';
import './reporting.css'
import { ContainerBody } from '../../App';
const Reporting = () => {
    return(
        <ContainerBody className="reporting__body">
            
            <Output/>
        </ContainerBody>
        
    )
    return (
    
        <div className="reporting__body">
            {/* <div className="reporting__body__extrainfo">
                <img src={mark} alt="" />
                <h4>This mark indicates that your product information has ben fully filled in</h4>
            </div> */}
            <div className="reporting__body__items">
                <div className="reporting__infos">
                    <div className="reporting__info">
                        <h4>Company Name:</h4><p>Lexikat Pte, Ltd.</p>
                    </div>
                    <div className="reporting__info">
                        <h4>Upload Company Logo:</h4><p>test</p>
                    </div>
                    <div className="reporting__info">
                        <h4>Company Location:</h4><p>Singapore</p>
                    </div>
                    <div className="reporting__info">
                        <h4>Company Size:</h4><p>5 people</p>
                    </div>
                    <div className="reporting__info">
                        <h4>Electricity Usage:</h4><p>20000 kW</p>
                    </div>
                    <div className="reporting__info">
                        <h4>Water Usage:</h4><p>20000 litres</p>
                    </div>
                    <div className="reporting__info">
                        <h4>Total CO2 Emissions:</h4><p>4800 kg</p>
                    </div>
                </div>
                <div className="reporting__recommendation">
                    <h4>Recommended news articles</h4>
                    <h4>Recommended certifications</h4>
                    <h4>Key regulations</h4>
                </div>
                
            </div>
            
        </div>
        
    );
}

const OldReporting = () => {

    const [yourproducts,setyourproducts] = useState([]);
    return ( 
    <div className="oldreporting">
    
        <img src={logo}  className="oldreporting__top"/>
        <div className="oldreporting__bottom">
        <div className="oldreporting__info">
            <h4>Company Name:</h4><p>test</p>
            <h4>Upload Company Logo:</h4><p>test</p>
            <h4>Company Location:</h4><p>test</p>
            <h4>Company Size:</h4><p>test</p>
            <h4>Electricity Usage:</h4><p>test</p>
            <h4>Water Usage:</h4><p>test</p>
            <h4>Total CO2 Emissions:</h4><p>test</p>
        </div>
        <div className="oldreporting__recommendation">
            <h4>Recommended news articles</h4>
            <h4>Recommended certifications</h4>
            <h4>Key regulations</h4>
        </div>
        
            
            
        </div>
    </div> );
}
 
export default Reporting;